import { render, staticRenderFns } from "./ConfigDrawer.vue?vue&type=template&id=08e18abc&"
import script from "./ConfigDrawer.vue?vue&type=script&lang=ts&"
export * from "./ConfigDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports